import { Menu, Select } from 'antd'
import { useSelector } from 'react-redux'
import { faExclamationTriangle, faFilter, faSignal } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isNonEmptyArray } from '../../../utils'
import { getSeverityTag, getStatusTag, getTypeLabel, Severities, Statuses, Types } from '../../../utils/entities/aphmAnomaly'

const SELECTOR_STYLE = { width: '230px' }
const MENU_ITEM_STYLE = { cursor: 'default', height: 'auto', lineHeight: 1.5, overflow: 'visible', padding: '4px 16px' }

export const DEFAULT_APHM_ANOMALY_FILTERS = Object.freeze({
  status: Statuses.OPEN,
  severity: [],
  type: []
})

export const getActiveFiltersCount = filters => {
  const state = filters ?? {}
  let count = 0

  if (state.status) { count += 1 }
  if (isNonEmptyArray(state.severity)) { count += 1 }
  if (isNonEmptyArray(state.type)) { count += 1 }

  return count
}

const AphmAnomalyFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const change = (key, value) => onFiltersChange({ ...filters, [key]: value })

  return (
    <Menu>
      <Menu.Item key='status' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faFilter} fontSize={FontSizes.SMALL} text={t('common.status')} />
        <Select
          allowClear
          style={SELECTOR_STYLE}
          value={filters?.status ?? undefined}
          placeholder={t('aphm_anomaly.filters.any_status')}
          onChange={value => change('status', value ?? null)}
        >
          {Object.values(Statuses).map(status => (
            <Select.Option key={status} value={status}>{t(getStatusTag(status).label)}</Select.Option>
          ))}
        </Select>
      </Menu.Item>

      <Menu.Item key='severity' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faSignal} fontSize={FontSizes.SMALL} text={t('aphm_anomaly.severity_label')} />
        <Select
          mode='multiple'
          allowClear
          style={SELECTOR_STYLE}
          value={filters?.severity ?? []}
          placeholder={t('aphm_anomaly.filters.any_severity')}
          onChange={value => change('severity', value)}
        >
          {Object.values(Severities).map(severity => (
            <Select.Option key={severity} value={severity}>{t(getSeverityTag(severity).label)}</Select.Option>
          ))}
        </Select>
      </Menu.Item>

      <Menu.Item key='type' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faExclamationTriangle} fontSize={FontSizes.SMALL} text={t('common.type')} />
        <Select
          mode='multiple'
          allowClear
          style={SELECTOR_STYLE}
          value={filters?.type ?? []}
          placeholder={t('aphm_anomaly.filters.any_type')}
          onChange={value => change('type', value)}
        >
          {Object.values(Types).map(type => (
            <Select.Option key={type} value={type}>{t(getTypeLabel(type))}</Select.Option>
          ))}
        </Select>
      </Menu.Item>
    </Menu>
  )
}

export default AphmAnomalyFilters
